import { Temporal } from '@js-temporal/polyfill'

/**
 * Gets the current local time and treats it as UTC.
 * E.g., if device is in GMT-3 and shows 08:00 local, returns an Instant representing 08:00 UTC.
 * This is used for scheduling and display so the player ignores timezone offsets.
 */
export function getLocalAsUtcInstant(): Temporal.Instant {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1 // 0-11 -> 1-12
  const day = now.getDate()
  const hour = now.getHours()
  const minute = now.getMinutes()
  const second = now.getSeconds()
  const millisecond = now.getMilliseconds()
  // Build ISO string from local components and parse as UTC
  const iso = `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}.${String(millisecond).padStart(3, '0')}Z`
  return Temporal.Instant.from(iso)
}
